/** Saves a CSV response and returns the file name the API gave it. */
const downloadCsv = async (res, fallback = "door-logs.csv") => {
  const disposition = res.headers.get("Content-disposition") || "";
  const filename = /filename=([^;]+)/.exec(disposition)?.[1] || fallback;
  const url = URL.createObjectURL(await res.blob());
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
  return filename;
};

export default downloadCsv;
